const announcementBar = () => {
    let timeToEnd;
    let countDownDate;
    const getCountDownString = () => {
        const now = new Date().getTime();
        timeToEnd = countDownDate - now;
        const days = Math.floor(timeToEnd / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeToEnd % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeToEnd % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeToEnd % (1000 * 60)) / 1000);
        let dayString;
        if (days > 0) {
            dayString = `${days}D`;
        }
        else {
            dayString = '';
        }
        let hoursString;
        if (hours > 0) {
            hoursString = ` ${hours}H`;
        }
        else {
            hoursString = '';
        }
        const minutesString = ` ${minutes}M`;
        const secondsString = `${seconds < 10 ? ` 0${seconds}S` : ` ${seconds}S`}`;
        return `${dayString}${hoursString}${minutesString}${secondsString}`;
    };
    const countdownTimer = () => {
        Array.from(document.querySelectorAll('[data-countdown-message]')).map((countdown) => {
            //Get the date set in Shopify
            const date = new Date(countdown.attributes['data-countdown-endtime'].value);
            //When countdown is enabled
            if (countdown.attributes['data-countdown-message']) {
                const contentDiv = countdown.querySelector('[data-countdown-message-text]');
                const contentText = contentDiv.innerText;
                const splitContent = contentText.split('[CD]');
                countDownDate = date.getTime();
                const now = new Date().getTime();
                timeToEnd = countDownDate - now;
                if (timeToEnd >= 0) {
                    contentDiv.classList.add('show');
                    contentDiv.innerHTML = splitContent.join(getCountDownString());
                }
                else if (timeToEnd <= 0) {
                    contentDiv.classList.remove('show');
                    countdown.remove();
                }
                const countDownTimer = setInterval(() => {
                    contentDiv.innerHTML = splitContent.join(getCountDownString());
                    //If the countdown has ended, revert to default
                    if (timeToEnd <= 0) {
                        contentDiv.classList.remove('show');
                        countdown.remove();
                        clearInterval(countDownTimer);
                    }
                }, 1000);
            }
        });
    };
    countdownTimer();
};
export { announcementBar };
